[
  {
    "date": "2020-04-03",
    "company_name": "Traveloka",
    "total_impacted": 100,
    "link": "https://www.cnbcindonesia.com/tech/20220531155201-37-343281/startup-ri-phk-ratusan-pegawai-selama-pandemi-ini-daftarnya"
  },
  {
    "date": "2020-04-15",
    "company_name": "SweetEscape",
    "total_impacted": 50,
    "link": "https://www.cnbcindonesia.com/tech/20220531155201-37-343281/startup-ri-phk-ratusan-pegawai-selama-pandemi-ini-daftarnya"
  },
  {
    "date": "2020-07-30",
    "company_name": "GudangAda",
    "total_impacted": 25,
    "link": "https://www.techinasia.com/gudangada-lays-off"
  },
  {
    "date": "2022-02-22",
    "company_name": "Tanihub",
    "total_impacted": 20,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-04-15",
    "company_name": "Akulaku",
    "total_impacted": 100,
    "link": "https://www.cnbcindonesia.com/tech/20220531155201-37-343281/startup-ri-phk-ratusan-pegawai-selama-pandemi-ini-daftarnya"
  },
  {
    "date": "2022-04-25",
    "company_name": "Stoqo",
    "total_impacted": 250,
    "link": "https://www.cnbcindonesia.com/tech/20220531155201-37-343281/startup-ri-phk-ratusan-pegawai-selama-pandemi-ini-daftarnya"
  },
  {
    "date": "2022-05-24",
    "company_name": "LinkAja",
    "total_impacted": 200,
    "link": "https://finansial.bisnis.com/read/20220524/563/1536528/blak-blakan-linkaja-terkait-phk-karyawan"
  },
  {
    "date": "2022-05-25",
    "company_name": "Zenius",
    "total_impacted": 200,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-06-02",
    "company_name": "Pahamify",
    "total_impacted": 50,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-06-09",
    "company_name": "Lummo",
    "total_impacted": 150,
    "link": "https://www.techinasia.com/lummo-layoff"
  },
  {
    "date": "2022-06-23",
    "company_name": "Mamikos",
    "total_impacted": 100,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-06-23",
    "company_name": "Gojek",
    "total_impacted": 430,
    "link": "https://www.cnbcindonesia.com/tech/20220531155201-37-343281/startup-ri-phk-ratusan-pegawai-selama-pandemi-ini-daftarnya"
  },
  {
    "date": "2022-06-27",
    "company_name": "JD.ID",
    "total_impacted": 20,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-08-04",
    "company_name": "Zenius",
    "total_impacted": 600,
    "link": "https://dailysocial.id/post/daftar-startup-yang-melakukan-phk-massal-sepanjang-2022"
  },
  {
    "date": "2022-10-19",
    "company_name": "Binar",
    "total_impacted": 160,
    "link": "https://tekno.kompas.com/read/2022/10/19/11450027/startup-pendidikan-binar-phk-20-persen-karyawan"
  },
  {
    "date": "2022-11-07",
    "company_name": "Koinworks",
    "total_impacted": 70,
    "link": "https://dailysocial.id/post/koinworks-layoff"
  },
  {
    "date": "2022-11-18",
    "company_name": "GoTo (Gojek Tokopedia)",
    "total_impacted": 1300,
    "link": "https://tekno.kompas.com/read/2022/11/27/12040057/4-startup-di-indonesia-yang-phk-karyawan-dalam-sebulan-terakhir?page=all"
  },
  {
    "date": "2022-11-21",
    "company_name": "Ruangguru",
    "total_impacted": 200,
    "link": "https://dailysocial.id/post/ruangguru-layoff-2022"
  },
  {
    "date": "2022-11-22",
    "company_name": "Sirclo",
    "total_impacted": 160,
    "link": "https://dailysocial.id/post/sirclo-layoff-2022"
  },
  {
    "date": "2022-11-22",
    "company_name": "Tokocrypto",
    "total_impacted": 45,
    "link": "https://indonesia.postsen.com/business/299750/Plus-SIRCLO-this-is-a-list-of-19-Indonesian-companies-that-have-laid-off-employees.html"
  },
  {
    "date": "2022-11-23",
    "company_name": "Anteraja",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-11-24",
    "company_name": "Shopee",
    "total_impacted": 186,
    "link": "https://www.urbanjabar.com/hype/pr-924903907/shopee-indonesia-layoff-besar-besaran-ternyata-faktor-ini-penyebabnya"
  },
  {
    "date": "2022-11-24",
    "company_name": "ZEN Rooms",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-11-25",
    "company_name": "Bukuwarung",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-11-29",
    "company_name": "Ajaib",
    "total_impacted": 67,
    "link": "https://www.techinasia.com/indonesian-investment-platform-ajaib-lays-8-headcount"
  },
  {
    "date": "2022-11-30",
    "company_name": "Ula",
    "total_impacted": 134,
    "link": "https://dailysocial.id/post/ula-layoff-2022"
  },
  {
    "date": "2022-12-01",
    "company_name": "Tanihub",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-05",
    "company_name": "Brick",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-07",
    "company_name": "Sayurbox",
    "total_impacted": 40,
    "link": "https://www.cnbcindonesia.com/tech/20221207182520-37-394710/lagi-phk-startup-giliran-sayurbox-pangkas-5-karyawan"
  },
  {
    "date": "2022-12-11",
    "company_name": "Shipper",
    "total_impacted": 65,
    "link": "https://www.cnbcindonesia.com/tech/20221213085136-37-396318/startup-shipper-phk-65-karyawan-alasannya-makroekonomi/amp"
  },
  {
    "date": "2022-12-12",
    "company_name": "Kopi Kenangan",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-12",
    "company_name": "Bhinneka.com",
    "total_impacted": 4,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-13",
    "company_name": "Warung Pintar",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-14",
    "company_name": "JD.ID",
    "total_impacted": 200,
    "link": "https://jakartaglobe.id/tech/jdid-layoffs-reflect-struggles-in-indonesian-startup-industry"
  },
  {
    "date": "2022-12-14",
    "company_name": "Alodokter",
    "total_impacted": 10,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-17",
    "company_name": "Stockbit",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-19",
    "company_name": "Tokocrypto",
    "total_impacted": 19,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-20",
    "company_name": "Tokocrypto",
    "total_impacted": 90,
    "link": "https://www.cnnindonesia.com/ekonomi/20221219171236-92-889397/badai-phk-masih-berlanjut-tokocrypto-pangkas-sejumlah-karyawan"
  },
  {
    "date": "2022-12-20",
    "company_name": "Koinworks",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2022-12-26",
    "company_name": "Bukalapak",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-03",
    "company_name": "Hangry",
    "total_impacted": 219,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-04",
    "company_name": "Segari",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-05",
    "company_name": "Kitabeli",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-09",
    "company_name": "Pinhome",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-10",
    "company_name": "Pegipegi",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-12",
    "company_name": "Fazz",
    "total_impacted": 40,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-17",
    "company_name": "Traveloka",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-17",
    "company_name": "Mitracomm",
    "total_impacted": 40,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-18",
    "company_name": "Klikdokter",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-01-20",
    "company_name": "Ajaib",
    "total_impacted": "unknown",
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-02-01",
    "company_name": "OLX",
    "total_impacted": 300,
    "link": "https://www.cnbcindonesia.com/tech/20230201063924-37-409886/olx-phk-300-pegawai-mau-hengkang-dari-indonesia"
  },
  {
    "date": "2023-02-09",
    "company_name": "Moladin",
    "total_impacted": 400,
    "link": "https://www.idntimes.com/business/economy/ridwan-aji-pitoko-1/badai-berlanjut-moladin-phk-200-lebih-karyawan"
  },
  {
    "date": "2023-02-17",
    "company_name": "Lifepal",
    "total_impacted": "unknown",
    "link": "https://id.techinasia.com/klarifikasi-lifepal-phk"
  },
  {
    "date": "2023-03-05",
    "company_name": "Brankas",
    "total_impacted": 20,
    "link": "https://murzfeed.softr.app/"
  },
  {
    "date": "2023-03-09",
    "company_name": "Shopee",
    "total_impacted": 200,
    "link": "https://gizmologi.id/news/shopee-kembali-layoff-karyawan-ini-sebabnya/"
  },
  {
    "date": "2023-03-10",
    "company_name": "GoTo (Gojek Tokopedia)",
    "total_impacted": 600,
    "link": "https://www.cnnindonesia.com/ekonomi/20230310154101-92-923437/goto-kembali-phk-600-karyawan"
  },
  {
    "date": "2023-04-14",
    "company_name": "Sayurbox",
    "total_impacted": "unknown",
    "link": "https://www.cnbcindonesia.com/tech/20230414134641-37-429990/sayurbox-phk-massal-karyawan-jelang-lebaran"
  },
  {
    "date": "2023-06-17",
    "company_name": "Lamudi",
    "total_impacted": 200,
    "link": "https://twitter.com/ecommurz/status/1680872657951293441"
  },
  {
    "date": "2023-07-02",
    "company_name": "Anteraja",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/anteraja-20230712021226"
  },
  {
    "date": "2023-07-05",
    "company_name": "Sirclo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/sirclo-20230712021236"
  },
  {
    "date": "2023-07-09",
    "company_name": "Mapan",
    "total_impacted": 65,
    "link": "https://murzfeed.com/p/mapan-layoff-65-orang-20230718150813"
  },
  {
    "date": "2023-07-09",
    "company_name": "Shipper",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/shipper-20230718014532"
  },
  {
    "date": "2023-07-14",
    "company_name": "OKHOME",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/okhome-20230720153814"
  },
  {
    "date": "2023-07-15",
    "company_name": "Akseleran",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/akseleran-20230726150407"
  },
  {
    "date": "2023-07-20",
    "company_name": "Bukalapak",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/-lupa-20230729034028"
  },
  {
    "date": "2023-08-05",
    "company_name": "iSeller",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/i-seller-commercd-20230808083828"
  },
  {
    "date": "2023-08-05",
    "company_name": "Stockbit",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/stockbit-20230804101023"
  },
  {
    "date": "2023-08-07",
    "company_name": "Qoala",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/qoala-got-layoff-today-20230731025002"
  },
  {
    "date": "2023-08-12",
    "company_name": "Ayoconnect",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/ayoconnect-20230801172822"
  },
  {
    "date": "2023-08-13",
    "company_name": "Xendit",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/xendit-20230816052543"
  },
  {
    "date": "2023-08-14",
    "company_name": "Hypefast",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/hypefast-20230822132326"
  },
  {
    "date": "2023-08-15",
    "company_name": "Privy",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/privy-20230827001556"
  },
  {
    "date": "2023-08-22",
    "company_name": "Bhinneka",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/bhinneka-20230829152340"
  },
  {
    "date": "2023-08-25",
    "company_name": "Delos Aqua",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/delos-aqua-20230811102832"
  },
  {
    "date": "2023-08-26",
    "company_name": "Noice",
    "total_impacted": 50,
    "link": "https://murzfeed.com/p/noice-20230815010318"
  },
  {
    "date": "2023-08-27",
    "company_name": "Pluang",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/pluang-20230819074701"
  },
  {
    "date": "2023-08-28",
    "company_name": "Shipper",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/another-silent-l-from-shipper-20230808152420"
  },
  {
    "date": "2023-08-30",
    "company_name": "Bukalapak",
    "total_impacted": 3,
    "link": "https://murzfeed.com/p/bukalapak-20230805115319"
  },
  {
    "date": "2023-08-31",
    "company_name": "Privy",
    "total_impacted": 100,
    "link": "https://murzfeed.com/p/suspectedly-theres-layoff-happening-in-pr-v-20230829084037"
  },
  {
    "date": "2023-08-31",
    "company_name": "DailySocial.id",
    "total_impacted": 40,
    "link": "https://murzfeed.com/p/daily-social-id-layoff-20230829052334"
  },
  {
    "date": "2023-08-31",
    "company_name": "Pintarnya",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/pintarnya-layoff-20230801133652"
  },
  {
    "date": "2023-09-02",
    "company_name": "Everplate",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/everplate-layoff-shutdown-20230922154206"
  },
  {
    "date": "2023-09-02",
    "company_name": "GoTo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/go-to-financial-20230918134334"
  },
  {
    "date": "2023-09-04",
    "company_name": "Ajaib",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/psss-ajaib-20230916022157"
  },
  {
    "date": "2023-09-06",
    "company_name": "EdenFarm's",
    "total_impacted": 378,
    "link": "https://murzfeed.com/p/eden-farms-biggest-layoff-20230926032741"
  },
  {
    "date": "2023-09-10",
    "company_name": "Pinhome",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/p-n-h-me-20230914105630"
  },
  {
    "date": "2023-09-11",
    "company_name": "Xtrememax",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/another-round-of-layoffs-at-xtremax-20230914130840"
  },
  {
    "date": "2023-09-15",
    "company_name": "Gudangada",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/gudangada-20230907093231"
  },
  {
    "date": "2023-09-16",
    "company_name": "Spenmo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/spenmo-layoff-wave-2-20230929084640"
  },
  {
    "date": "2023-09-16",
    "company_name": "Lazada",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/lzd-silent-layoff-20230922155714"
  },
  {
    "date": "2023-09-19",
    "company_name": "Alami",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/alami-20230902154857"
  },
  {
    "date": "2023-09-20",
    "company_name": "Virgo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/is-l-happening-at-vrigo-20230915061347"
  },
  {
    "date": "2023-09-21",
    "company_name": "Gudangada",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/gudangada-20230908230552"
  },
  {
    "date": "2023-09-27",
    "company_name": "Kompas Gramedia",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/divisi-it-kompas-gramedia-terkena-layoff-20230925122706"
  },
  {
    "date": "2023-09-30",
    "company_name": "Dailysocial",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/dailysocial-20230831111047"
  },
  {
    "date": "2023-10-01",
    "company_name": "Indodax",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/indodax-20231013033005"
  },
  {
    "date": "2023-10-09",
    "company_name": "Ula",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/ula-did-it-again-20231004010125"
  },
  {
    "date": "2023-10-12",
    "company_name": "99.co",
    "total_impacted": 8,
    "link": "https://murzfeed.com/p/99-group-99-co-rumah-123-20231020073227"
  },
  {
    "date": "2023-10-15",
    "company_name": "Pinhome",
    "total_impacted": 70,
    "link": "https://murzfeed.com/p/pinhome-20231011021625"
  },
  {
    "date": "2023-10-16",
    "company_name": "Ajaib",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/ajaib-layoff-20231013091302"
  },
  {
    "date": "2023-10-16",
    "company_name": "Bibit Stockbit",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/bibit-stockbit-layoff-20231013090954"
  },
  {
    "date": "2023-10-18",
    "company_name": "GoTo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/goto-ceo-briefing-is-scheduled-for-today-evening-20231020060909"
  },
  {
    "date": "2023-10-24",
    "company_name": "Shipper",
    "total_impacted": 100,
    "link": "https://murzfeed.com/p/reppihs-ada-l-words-20231011130141"
  },
  {
    "date": "2023-10-26",
    "company_name": "Carsome",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/carsome-20231023165829"
  },
  {
    "date": "2023-10-26",
    "company_name": "Indodax",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/indodax-layoff-20231013033516"
  },
  {
    "date": "2023-10-30",
    "company_name": "Xtremax",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/xtremax-layoff-batch-2-20231002083252"
  },
  {
    "date": "2023-11-10",
    "company_name": "ORBIT",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/orbit-future-academy-20231109040706"
  },
  {
    "date": "2023-11-11",
    "company_name": "Carsome",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/carsome-indonesia-20231115033741"
  },
  {
    "date": "2023-11-19",
    "company_name": "Halodoc",
    "total_impacted": 14,
    "link": "https://murzfeed.com/p/l-word-will-happening-20231113151653"
  },
  {
    "date": "2023-11-21",
    "company_name": "Indodax",
    "total_impacted": 23,
    "link": "https://murzfeed.com/p/indodax-20231005033036"
  },
  {
    "date": "2023-11-26",
    "company_name": "Gudangada",
    "total_impacted": 150,
    "link": "https://murzfeed.com/p/gudang-da-20231117100407"
  },
  {
    "date": "2023-12-01",
    "company_name": "Bobobox",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/bbx-officially-l-20231206072936"
  },
  {
    "date": "2023-12-02",
    "company_name": "hubster",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/hubster-20231129081433"
  },
  {
    "date": "2023-12-03",
    "company_name": "Realtegic",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/realtegic-group-20231202074551"
  },
  {
    "date": "2023-12-04",
    "company_name": "Vidio",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/vidio-20231216091500"
  },
  {
    "date": "2023-12-06",
    "company_name": "Unilateral",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/unilateral-employee-terminations-at-foom-20231229091620"
  },
  {
    "date": "2023-12-19",
    "company_name": "Bukalapak",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/lupabapak-20231130072441"
  },
  {
    "date": "2023-12-23",
    "company_name": "Bizhare",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/bizhare-layoff-for-several-departments-20231204034703"
  },
  {
    "date": "2023-12-26",
    "company_name": "Republika",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/republika-20231213165916"
  },
  {
    "date": "2024-01-02",
    "company_name": "Flip",
    "total_impacted": 20,
    "link": "https://murzfeed.com/p/flip-layoff-20240113135220"
  },
  {
    "date": "2024-01-04",
    "company_name": "Danacita",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/danacita-fintech-layoff-pt-2-20240109093635"
  },
  {
    "date": "2024-01-06",
    "company_name": "Google Indonesia",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/another-layoff-in-google-indo-20240118052933"
  },
  {
    "date": "2024-01-09",
    "company_name": "MNC News",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/layoff-at-mnc-groups-news-portal-20240103170036"
  },
  {
    "date": "2024-01-14",
    "company_name": "Laku6",
    "total_impacted": 30,
    "link": "https://murzfeed.com/p/laku-6-layoff-30-20240116082141"
  },
  {
    "date": "2024-01-15",
    "company_name": "Tokopedia",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/tgl-15-16-jan-l-word-di-tokopedia-tik-tok-20240110132657"
  },
  {
    "date": "2024-01-17",
    "company_name": "Xendit",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/xendit-layoffs-20240122020937"
  },
  {
    "date": "2024-01-17",
    "company_name": "Traveloka",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/trvlk-l-word-20240104024556"
  },
  {
    "date": "2024-01-18",
    "company_name": "Flash",
    "total_impacted": 20,
    "link": "https://murzfeed.com/p/flash-coffee-layoff-20240103174531"
  },
  {
    "date": "2024-01-28",
    "company_name": "Lazada",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/lzd-l-word-around-30-50-each-team-20240103135707"
  },
  {
    "date": "2024-02-05",
    "company_name": "Accelbyte",
    "total_impacted": 80,
    "link": "https://murzfeed.com/p/accelb-te-laid-off-20-around-80-people-impacted-20240229080016"
  },
  {
    "date": "2024-02-19",
    "company_name": "Waresix",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/waresix-layoff-20240217041641"
  },
  {
    "date": "2024-02-25",
    "company_name": "Lazada",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/lzd-people-team-got-layoff-20240223061746"
  },
  {
    "date": "2024-03-21",
    "company_name": "Smartfren",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/smartfren-panic-and-brutal-layoff-20240321121618"
  },
  {
    "date": "2024-03-22",
    "company_name": "KUPU.ID",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/kupu-id-layoff-20240307044015"
  },
  {
    "date": "2024-03-28",
    "company_name": "eFishery",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/e-l-word-20240327045930"
  },
  {
    "date": "2024-04-08",
    "company_name": "OKHOME",
    "total_impacted": 20,
    "link": "https://murzfeed.com/p/ok-rumah-second-wave-lay-off-20240402153959"
  },
  {
    "date": "2024-04-11",
    "company_name": "Amartha",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/amartha-20240422083009"
  },
  {
    "date": "2024-04-30",
    "company_name": "Bukalapak",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/lupa-gl-part-sekian-20240427045019"
  },
  {
    "date": "2024-05-04",
    "company_name": "Crowde",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/crowde-putus-kontrak-krywan-20240509022857"
  },
  {
    "date": "2024-05-21",
    "company_name": "Layoff",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/layoff-berkedok-performance-di-populix-20240521093455"
  },
  {
    "date": "2024-05-21",
    "company_name": "Reliance Finance",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/reliance-finance-layoff-beberapa-tim-20240515053604"
  },
  {
    "date": "2024-05-24",
    "company_name": "Fazz",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/silent-l-fazz-20240524093411"
  },
  {
    "date": "2024-05-28",
    "company_name": "Tokopedia",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/tokopedia-l-word-20240520033855"
  },
  {
    "date": "2024-05-30",
    "company_name": "Tiktok",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/t-k-t-k-layoff-20240530000320"
  },
  {
    "date": "2024-05-31",
    "company_name": "Jatis Mobile",
    "total_impacted": 32,
    "link": "https://murzfeed.com/p/layoff-at-jatis-mobile-32-people-20240531103633"
  },
  {
    "date": "2024-05-31",
    "company_name": "Populix",
    "total_impacted": 5,
    "link": "https://murzfeed.com/p/populix-layoffs-several-engineers-20240530134655"
  },
  {
    "date": "2024-06-14",
    "company_name": "Tokopedia",
    "total_impacted": 450,
    "link": "https://www.cnnindonesia.com/ekonomi/20240614131848-92-1109898/ramai-karyawan-tokopedia-keluhkan-phk"
  },
  {
    "date": "2024-06-14",
    "company_name": "Sirclo",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/sirclo-layoff-lagi-20240613163736"
  },
  {
    "date": "2024-06-15",
    "company_name": "Bytedance",
    "total_impacted": "unknown",
    "link": "https://murzfeed.com/p/bytedance-balas-dendam-20240614052528"
  }
]